import { createFileRoute, Outlet } from '@tanstack/react-router';

import { isHTTPError } from 'ky';

import { AuthenticatedLayout } from '@/components/layouts/AuthenticatedLayout';
import { RouteError } from '@/components/RouteError';
import { userQueryOptions } from '@/features/user/data/useUser';
import { queryClient } from '@/query-client';
import { API_URL, APP_URL } from '@/utils/environment';

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: async () => {
    try {
      await queryClient.ensureQueryData(userQueryOptions);
    } catch (error) {
      if (isHTTPError(error) && error.response.status === 401) {
        globalThis.location.replace(`${API_URL}/api/v1/web/auth/login?redirectUri=${APP_URL}`);
        return;
      }
      throw error;
    }
  },
  component: AppLayout,
  errorComponent: ({ error, reset }) => <RouteError error={error} reset={reset} />,
});

function AppLayout() {
  return (
    <AuthenticatedLayout>
      <Outlet />
    </AuthenticatedLayout>
  );
}
